import { useState } from 'react';

import type { ActionIntent } from '../../services/agentDraftApi';

interface User {
  id: string;
  name: string;
  avatarUrl?: string;
}

interface UserPickerMessageProps {
  users: User[];
  onConfirm: (params: { displayMessage: string; intent: ActionIntent }) => void;
}

export function UserPickerMessage({ users, onConfirm }: UserPickerMessageProps) {
  const [selected, setSelected] = useState<string[]>([]);

  const toggle = (id: string) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id],
    );
  };

  const handleConfirm = () => {
    if (!selected.length) return;
    const names = users
      .filter((u) => selected.includes(u.id))
      .map((u) => u.name)
      .join(', ');
    onConfirm({
      displayMessage: `Quero receber agendamentos para: ${names}`,
      intent: { type: 'set_calendar_users', payload: { userIds: selected } },
    });
  };

  return (
    <div data-testid="user-picker-message" style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 8 }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
        {users.map((user) => {
          const isSelected = selected.includes(user.id);
          return (
            <button
              key={user.id}
              onClick={() => toggle(user.id)}
              data-testid={`user-picker-option-${user.id}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '6px 12px',
                borderRadius: 8,
                border: `2px solid ${isSelected ? '#8b5cf6' : '#e5e7eb'}`,
                background: isSelected ? '#f5f3ff' : '#fff',
                cursor: 'pointer',
                fontSize: 14,
                fontWeight: 500,
                color: '#374151',
              }}
            >
              {user.avatarUrl ? (
                <img
                  src={user.avatarUrl}
                  alt={user.name}
                  style={{ width: 24, height: 24, borderRadius: '50%' }}
                />
              ) : (
                <div
                  style={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    background: '#8b5cf6',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: 11,
                    fontWeight: 700,
                  }}
                >
                  {user.name.charAt(0).toUpperCase()}
                </div>
              )}
              {user.name}
            </button>
          );
        })}
      </div>
      <button
        onClick={handleConfirm}
        disabled={!selected.length}
        data-testid="user-picker-confirm"
        style={{
          alignSelf: 'flex-start',
          padding: '8px 16px',
          borderRadius: 8,
          border: 'none',
          background: selected.length ? '#8b5cf6' : '#e5e7eb',
          color: selected.length ? '#fff' : '#9ca3af',
          fontWeight: 600,
          fontSize: 14,
          cursor: selected.length ? 'pointer' : 'not-allowed',
        }}
      >
        Confirmar seleção
      </button>
    </div>
  );
}
